// extracted by mini-css-extract-plugin
export var bodySections = "_52-8";
export var gray = "_52-7";
export var green = "_52-4";
export var iconContainer = "_52-9";
export var iconWidgetContainer = "_52-1";
export var phoneIcon = "_52-2";
export var red = "_52-5";
export var statusDot = "_52-3";
export var widgetContainer = "_52-0";
export var yellow = "_52-6";